import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormsModule } from '@angular/forms';
import { first } from 'rxjs/operators';

import { CommonDataService } from '../../services/common-data.service';
import { CommerceDataService } from '../../services/commerce-data.service';
import { environment } from '../../../environments/environment';

declare var $:any;
declare var iziToast:any;

@Component({
  selector: 'app-shop-cart-page',
  templateUrl: './shop-cart-page.component.html',
  styleUrls: ['./shop-cart-page.component.css']
})
export class ShopCartPageComponent implements OnInit {
  
  pageName = "Your Shopping Cart";

  cartItems = []
  numberOfItems = 0
  //calculated from the commerce data service
  cartTotalBreakDown
  cartItemsSubscription;
  shoppingCartEmpty
  cartPoints = 0

  constructor(
    private router: Router,
    private _data: CommonDataService,
    private _ecomm: CommerceDataService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {

    $('#initialise-page').trigger('click');
    $('#owl-initialise').trigger('click');

    let cartItems = localStorage.getItem("cartItems")
    
    if(cartItems) {
      this.cartItems = JSON.parse(localStorage.getItem("cartItems"))
      this.numberOfItems = this.cartItems.length
    }
    this.cartTotalBreakDown = this._ecomm.calculateCartTotal()
    this.cartPoints = this._ecomm.getCartEarnPoints()

    //Subscribe to the cart items changes and update this cart items every time there is new updates
    this.cartItemsSubscription = this._ecomm.cartItemsChanged.subscribe(
      (data) => {
        this.cartItems = data;
        console.log(this.cartItems)
        this.numberOfItems = this.cartItems.length
        this.cartTotalBreakDown = this._ecomm.calculateCartTotal()
        this.cartPoints = this._ecomm.getCartEarnPoints()
      }
    );
  }

  getProductImageSrc(modelData){

    if( modelData['files'] && modelData['files']['uploads'] && Array.isArray(modelData['files']['uploads']) && modelData['files']['uploads'].length > 0) {
      let productImages = modelData['files']['uploads']

      for (let index = 0; index < productImages.length; index++) {
        let element = productImages[index];

        if(element['tmp_name'] && element['tmp_name'] != '') {
          let srcStrings = element['tmp_name'].split("public/");
          let src = environment.filesSrc+'/'+srcStrings[1]
          element['src'] = src
          return src
        }
        
      }

    }

      return ''
  }

  clearCart() {

    this._ecomm.emptyShoppingCart()

    let h = {
      class: "iziToast-info",
      title:  "Cart Empty:",
      message:  "fill up your cart with your favourite products",
      animateInside: !1,
      position: "topRight",
      progressBar: !1,
      icon: "icon-bell",
      timeout: 3200,
      transitionIn: "fadeInLeft",
      transitionOut: "fadeOut",
      transitionInMobile: "fadeIn",
      transitionOutMobile: "fadeOut",
    };
    iziToast.show(h);


  }

  updateCartQuantity(qty, product) {
    this._ecomm.updateShoppingCart(product, qty)
  }

  removeItemFromCart(id, qty) {
    this._ecomm.removeFromShoppingCart(id)

    let h = {
      class: "iziToast-info",
      title:  "Cart Updated:",
      message:  qty+" item removed from cart",
      animateInside: !1,
      position: "topRight",
      progressBar: !1,
      icon: "icon-bell",
      timeout: 3200,
      transitionIn: "fadeInLeft",
      transitionOut: "fadeOut",
      transitionInMobile: "fadeIn",
      transitionOutMobile: "fadeOut",
    };
    iziToast.show(h);
  }

  getDiscount(product) {
    return parseFloat(product['cover']['model']['modelData']['formFieldsEntities']['productDetails']['regular_price']) - parseFloat(product['cover']['model']['modelData']['formFieldsEntities']['productDetails']['sale_price'])
  }

  goShopping() {
    this.router.navigate(['/shop/products']);
  }

  applyCoupon() {

    let h = {
      class: "iziToast-warning",
      title:  "Coupon Invalid:",
      message:  " please try again!",
      animateInside: !1,
      position: "topRight",
      progressBar: !1,
      icon: "icon-bell",
      timeout: 3200,
      transitionIn: "fadeInLeft",
      transitionOut: "fadeOut",
      transitionInMobile: "fadeIn",
      transitionOutMobile: "fadeOut",
    };

    iziToast.show(h);

  }

}
